export default "__VITE_ASSET__BxTtcPqo__"